import { CoinManagementService } from './coinManagementService';
import { CoinHistory } from '../types/alarm';

/**
 * StudentCoinService
 * 기존 인터페이스를 유지하면서 내부적으로 CoinManagementService를 사용
 */
export class StudentCoinService {
  private userId: string;
  private classId: string;
  private coinManagementService: CoinManagementService;

  constructor(userId: string, classId: string, memberGroup?: string) {
    this.userId = userId;
    this.classId = classId;
    this.coinManagementService = new CoinManagementService(userId, classId, memberGroup);
  }

  // 멤버에게 코인 지급 (내역 기록 포함)
  async grantCoinsToStudent(
    studentId: string, 
    amount: number, 
    memo: string = '코인 지급',
    coinType: 'General' | 'Levelup' = 'General'
  ): Promise<void> {
    await this.coinManagementService.grantCoinsToStudent(studentId, amount, memo, coinType);
  }

  // 여러 멤버에게 동시에 코인 지급
  async grantCoinsToMultipleStudents(
    studentIds: string[], 
    amount: number, 
    memo: string = '코인 지급',
    coinType: 'General' | 'Levelup' = 'General'
  ): Promise<void> {
    await this.coinManagementService.grantCoinsToMultipleStudents(studentIds, amount, memo, coinType);
  }

  // 멤버의 코인 사용 (차감)
  async useCoins(studentId: string, amount: number, memo: string = '코인 사용'): Promise<void> {
    // 음수로 지급하여 차감
    await this.coinManagementService.grantCoinsToStudent(studentId, -amount, memo, 'General');
  }

  // 멤버의 현재 코인 조회
  async getStudentCoins(studentId: string): Promise<number> {
    return await this.coinManagementService.getStudentCoins(studentId);
  }

  // 멤버의 코인 히스토리 조회
  async getStudentCoinHistory(studentId: string): Promise<CoinHistory[]> {
    return await this.coinManagementService.getStudentCoinHistory(studentId);
  }

  // 멤버의 코인 데이터 직접 업데이트
  async updateStudentCoinData(
    studentId: string,
    coins: number,
    coinsHistory: CoinHistory[]
  ): Promise<void> {
    await this.coinManagementService.updateStudentCoinData(studentId, coins, coinsHistory);
  }

  // 모든 멤버의 코인 초기화 (0으로 설정)
  async initializeAllStudentCoins(): Promise<void> {
    console.log(`🔄 모든 멤버 코인 초기화 - ClassMembersCoin에서 수행`);
    // 새 문서가 없으면 생성됨
    await this.coinManagementService.createNewMembersCoinDocument();
  }

  // 기존 ClassMembers에서 마이그레이션
  async migrateFromClassMembers(): Promise<void> {
    await this.coinManagementService.migrateFromClassMembers();
  }
}
